/**
 * UrbanFootprint App API
 * API for serving UrbanFootprint Application
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ClientResponse } from '../variables';

// @ts-ignore: This is used only for params, but some services have param-free APIs
import { PortfolioServiceInterface } from './portfolio.serviceInterface';

// @ts-ignore: These imports are for both params and returnType, but we only use returnType
import { PortfolioInfo } from '../model/portfolioInfo';
// @ts-ignore: These imports are for both params and returnType, but we only use returnType
import { ProblemDetail } from '../model/problemDetail';

/**
 * Package: api
 */

const listUserPortfoliosPrefix = `uf-api/portfolio/list_user_portfolios/`;
/**
 * Action types for portfolio.list_user_portfolios
 *
 * List user portfolios.
 */
export const listUserPortfoliosActionTypes = {
  LOAD: `${listUserPortfoliosPrefix}LOAD` as 'uf-api/portfolio/list_user_portfolios/LOAD',
  SUCCESS:
    `${listUserPortfoliosPrefix}SUCCESS` as 'uf-api/portfolio/list_user_portfolios/SUCCESS',
  FAILURE:
    `${listUserPortfoliosPrefix}FAILURE` as 'uf-api/portfolio/list_user_portfolios/FAILURE',
  CLEAR:
    `${listUserPortfoliosPrefix}CLEAR` as 'uf-api/portfolio/list_user_portfolios/CLEAR',
} as const;

/**
 * LOAD action for portfolio.list_user_portfolios
 * List user portfolios.
 */
export interface listUserPortfoliosLoadAction {
  readonly type: 'uf-api/portfolio/list_user_portfolios/LOAD';
  readonly params: PortfolioServiceInterface.listUserPortfoliosParams;
  readonly promise: Promise<ClientResponse<Array<PortfolioInfo>>>;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
  readonly key?: string;
}

/**
 * SUCCESS action for portfolio.list_user_portfolios
 * List user portfolios.
 */
export interface listUserPortfoliosSuccessAction {
  readonly type: 'uf-api/portfolio/list_user_portfolios/SUCCESS';
  readonly result: Array<PortfolioInfo>;
  readonly key?: string;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
}

/**
 * FAILURE action for portfolio.list_user_portfolios
 * List user portfolios.
 */
export interface listUserPortfoliosFailureAction {
  readonly type: 'uf-api/portfolio/list_user_portfolios/FAILURE';
  readonly error: any;
  readonly key?: string;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
}

/**
 * CLEAR action for portfolio.list_user_portfolios
 * List user portfolios.
 */
export interface listUserPortfoliosClearAction {
  readonly type: 'uf-api/portfolio/list_user_portfolios/CLEAR';
  readonly key: string;
}

export const portfolioActionTypesMap = {
  /** Action types for portfolio.list_user_portfolios */
  list_user_portfolios: listUserPortfoliosActionTypes,
} as const;

export const portfolioDetailsMap = {
  list_user_portfolios: {
    /** HTTP method for portfolio.list_user_portfolios */
    httpMethod: 'get' as const,
  },
} as const;

/**
 * Local DataState<T> - kept in sync with uf/data/dataState.ts
 */
interface DataState<T> {
  readonly loading: boolean;
  readonly loaded: boolean;
  readonly requestId: string;
  readonly requestTime?: string;
  readonly responseTime?: string;
  readonly requestCount?: number;
  readonly error?: any;
  readonly promise?: Promise<T>;
  readonly data?: T;
  readonly extra?: any;
  readonly key?: string;
}
export interface PortfolioServiceState {
  /** listUserPortfolios state, by key */
  list_user_portfolios: {
    readonly [key: string]: DataState<Array<PortfolioInfo>>;
  };
}
